import { createGlobalStyle } from 'styled-components';

import { pxToRem } from '@utils/converters';

import { theme } from './theme';

export const datepickerPopperSelector = '.react-datepicker-popper';

export const DatePickerStyles = createGlobalStyle`
  .react-datepicker {
    border: none;
    color: ${theme.color.textPrimary};
    background: ${theme.color.backgroundLightDark};
    box-shadow: ${theme.shadow.medium};
    font-family: "Work Sans", sans-serif;
    padding: 1.5rem;

    .not-current-month {
      opacity: 0.5;
    }

    .is-selected {
      opacity: 1;
      background-color: ${theme.color.elementBlue100} !important;
      color: ${theme.color.white100} !important;
    }
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  ${datepickerPopperSelector} {
    z-index: 10000;
  }

  .react-datepicker__header--custom {
    padding: 0;
    background-color: transparent;
    border-bottom: none;
  }

  .react-datepicker__day {
    font: ${theme.font.regular14};
    color: ${theme.color.textPrimary};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    outline: none;
    margin: 0;
    height: 2.5rem;
    width: 2.5rem;
    transition: all 300ms ease;
    :hover {
      color: ${theme.color.textPrimary};
      background-color: ${theme.color.uiTrans10};
    }
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__day--today{
    color: ${theme.color.elementBlue100};
    font: ${theme.font.semibold14};
    :hover {
      background-color: ${theme.color.uiTrans10};
    }
  }

  .react-datepicker__day--selected {
    background-color: ${theme.color.elementBlue100};
    color: ${theme.color.white100};
    font: ${theme.font.semibold14};
    outline: none;
    :hover {
      color: ${theme.color.white100};
      background-color: ${theme.color.elementBlue100};
    }
  }
  
  .react-datepicker__day--keyboard-selected {
    background-color: ${theme.color.elementBlue100};
    font: ${theme.font.semibold14};
    color: ${theme.color.white100};
    :hover {
      background-color: ${theme.color.elementBlue100};
    }
  }

  .react-datepicker__day-name {
    font: ${theme.font.semibold12};
    margin: 0;
    color: ${theme.color.textSecondary};
    width: 2.5rem;
  }

  .react-datepicker__day-names {
    height: 2.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  ${datepickerPopperSelector}[data-placement^=top] {
    padding-top: 0;
    padding-bottom: 0;
  }

  ${datepickerPopperSelector}[data-placement^=bottom] {
    padding-top: 0;
    padding-bottom: 0;
  }

  .calendar-inline {
    box-shadow: none;
    padding: 0;
  }


  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name, .react-datepicker__portal .react-datepicker__day, .react-datepicker__portal .react-datepicker__time-name {
      width: ${pxToRem(40)};
      line-height: ${pxToRem(40)};
    }
  }
`;
